var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseModal',{attrs:{"showing":_vm.visible},on:{"close":function($event){return _vm.$emit('close')},"opened":_vm.loadData}},[_c('BaseCard',{attrs:{"title":"Riwayat Status Faktur","description":"Riwayat Status Faktur","with-style":false}},[_c('BaseTimeline',{attrs:{"items":_vm.data}})],1)],1),(_vm.loading)?_c('loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }